// Note that we have separate date utils in this file from `dateHelper`
// as `dateHelper` contains functions that are intended to be mocked.
// Because we use functions from `dateHelper` within these tests,
// if we were to include these functions in the same file,
// it would be a nightmare / probably impossible to mock and test properly.

import {DATE_FORMAT_DB} from '@client/util/constants';
import {getDate} from '@client/util/dateHelper';
import isToday from 'date-fns/isToday';
import isFuture from 'date-fns/isFuture';
import parse from 'date-fns/parse';
import subMonths from 'date-fns/subMonths';
import subYears from 'date-fns/subYears';
import startOfMonth from 'date-fns/startOfMonth';
import startOfYear from 'date-fns/startOfYear';
import parseISO from 'date-fns/parseISO';

export const isTodayOrFuture = (dateString: string): boolean => {
  const passedDate = parse(dateString, DATE_FORMAT_DB, getDate());

  const future = isFuture(passedDate);
  const sameDay = isToday(passedDate);

  return future || sameDay;
};

export const qtdCalculation = (date: Date): Date => {
  const currentMonth = date.getMonth();
  const monthToSub = currentMonth - (currentMonth % 3);

  date.setMonth(monthToSub, 1);

  return date;
};

export const dateCalculation = (val: string, date: string): Date =>
  ({
    MTD: startOfMonth(parseISO(date)),
    YTD: startOfYear(parseISO(date)),
    QTD: qtdCalculation(parseISO(date)),
    '1M': subMonths(parseISO(date), 1),
    '1Y': subYears(parseISO(date), 1),
    '3M': subMonths(parseISO(date), 3),
  }[val]);

export const todaysDateFormatted = getDate();

export const getYear = (value: number): string => {
  const calenderYear = subYears(getDate(), value);

  return calenderYear.getFullYear().toString(10);
};

export const ageTillYearEnd = (dateString: string, withdrawalYear: number): number => {
  const yearEndDate = Number(parse(`${withdrawalYear}-12-31`, DATE_FORMAT_DB, getDate()));

  const clientDOB = Number(parse(dateString, DATE_FORMAT_DB, getDate()));

  /* * The magic number: 31557600000 is 24 * 3600 * 365.25 * 1000
  Which is the length of a year, the length of a year is 365 days
  and 6 hours which is 0.25 day.  * */

  return Number.parseFloat(((yearEndDate - clientDOB) / 31557600000).toFixed(2));
};
